// Centralized brand and version — brand is resolved at build time from REACT_APP_BRAND.
// Missing or unknown values throw at module load so there is no runtime fallback.

const BRAND_ENV = process.env.REACT_APP_BRAND;

let resolvedBrand;
switch (BRAND_ENV) {
  case "ringfoods":
    resolvedBrand = "RingFoods";
    break;
  case "ringoperator":
    resolvedBrand = "RingOperator";
    break;
  default:
    throw new Error(
      `Unknown or missing REACT_APP_BRAND: '${BRAND_ENV}'. Must be 'ringfoods' or 'ringoperator'.`
    );
}

export const APP_BRAND_KEY = BRAND_ENV; // 'ringfoods' | 'ringoperator'
export const APP_BRAND = resolvedBrand; // 'RingFoods' | 'RingOperator'
// Format: v.YYYYMMDDhhmm (12 digits)
export const APP_VERSION = "v.202611040812";
export const APP_BRAND_WITH_VERSION = `${APP_BRAND} ${APP_VERSION}`;
